import { DirectivePrefix } from '../enum/FormItemDirectivePrefix';
import { IAttributeFilterStrategy } from "./IAttributeFilterStrategy";

export class NgDirectiveFilterStrategy implements IAttributeFilterStrategy {
    // 匹配规则
    // 去除if、repeat等指令
    private matchRuler: Array<string> = ["ngModel", "ngMinlength", "ngMaxlength", "ngPattern", "ngRequired", "ngDisabled", "ngClass", "ngModelOptions"];

    constructor() { }

    // 判断指令是否匹配ng指令
    public isMatcher(directive: string): boolean {
        // 过滤出匹配的ng指令前缀
        if (this.matchRuler.indexOf(directive) > -1) {
            return true;
        }

        return false;
    }

    /**
     * @description 获取指令，并查看指令形式 eg: ngDisabled 或者 ngDisabled="false", 最后返回完整的指令
     * @param {string} key eg: ng-model
     * @param {string} value eg: text 或者 5 或者 false
     * @return {*}  {string} ng-disabled 或者 ng-model="ctrl.name"
     * @memberof NgDirectiveFilterStrategy
     */
    public getDirective(key: string, value: string): string {
        let directive = "";

        // 如果属性有写value则给属性添加value
        value == "" ? (directive += key) : (directive += key + "=" + "\"" + value + "\"");

        return directive;
    }
}